import { FormToggleButton } from "../../../../../components/fields";
import { Lock, LockOpen } from "@mui/icons-material";
import { useWatch, useFormContext } from "react-hook-form";
import { IFormValues, InsertBookingStep } from "../../../types";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { stepState } from "../../../recoil";

const LockGroup = () => {

    const step = useRecoilValue(stepState);

    const formContext = useFormContext<IFormValues>();

    const lockGroup = useWatch<IFormValues, "basicDetails.lockGroup">({
        name: 'basicDetails.lockGroup'
    });
    const carGroup = useWatch<IFormValues, "basicDetails.carGroup">({
        name: 'basicDetails.carGroup'
    });

    useEffect(() => {
        if (!carGroup) {
            formContext.resetField('basicDetails.lockGroup')
        } 
    }, [carGroup]);

    return (
        <FormToggleButton<IFormValues>
            name="basicDetails.lockGroup"
            disabled={!carGroup || step === InsertBookingStep.CUSTOMER_DETAILS}
        >
            {lockGroup ? <Lock /> : <LockOpen />}
        </FormToggleButton >
    );
};

export default LockGroup;